const changeType = {
  DORMANCY: {
    name: '休眠',
    code: '0'
  },
  SUSPEND: {
    name: '休学',
    code: '1'
  },
  REENTER: {
    name: '复学',
    code: '2'
  },
  ROLL_CLASS: {
    name: '转班',
    code: '3'
  },
  DROPOUT: {
    name: '退学',
    code: '4'
  },
  ROLL_STATE: {
    name: '跟读转正',
    code: '99'
  }
}

export default changeType
